import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getBaseUrl } from "../config";
import { getAuthApiHeaders } from "../../utils/common";
import { showSnackbar } from "./snackbar";
import { getApiErrorMessage } from "../../utils/apiError";
import secureLocalStorage from "react-secure-storage";
const baseUrl = getBaseUrl();
export const getUserName = createAsyncThunk(
  "userName/getUserName",
  async (mail, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`${baseUrl}/mr_info`, {
        headers: {
          "Content-Type": "application/json",
          "use-case": "src",
          ...getAuthApiHeaders(),
          client: mail.client ? mail.client : "UT",
        },
        withCredentials: true,
      });
      return response.data;
    } catch (error) {
      dispatch(showSnackbar({ message: "Failed to load!", severity: "error" }));
      return rejectWithValue(getApiErrorMessage(error));
    }
  },
);

const userNameSlice = createSlice({
  name: "user-name",
  initialState: {
    isLoading: false,
    userName: "",
    isError: false,
    error: null,
    success: false,
  },
  extraReducers: (builder) => {
    builder.addCase(getUserName.pending, (state, action) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getUserName.fulfilled, (state, action) => {
      state.isLoading = false;
      state.userName = action.payload;
      state.success = true;
    });
    builder.addCase(getUserName.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
      state.success = false;
    });
  },
});

export default userNameSlice.reducer;
